// constants
import { DisabilityActionTypes } from './constants';
import Disability from './model';

export interface DisabilityActionType {
    type:
        | DisabilityActionTypes.API_RESPONSE_SUCCESS
        | DisabilityActionTypes.API_RESPONSE_ERROR
        | DisabilityActionTypes.GET_DISABILITIES;
    payload: {} | string;
}

// common success
export const disabilitiesApiResponseSuccess = (
    actionType: string,
    data: Disability | Disability[] | {} | []
): DisabilityActionType => ({
    type: DisabilityActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const disabilitiesApiResponseError = (actionType: string, error: string): DisabilityActionType => ({
    type: DisabilityActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getDisabilities = (): DisabilityActionType => ({
    type: DisabilityActionTypes.GET_DISABILITIES,
    payload: {},
});
